import React from 'react';
import { Chip } from '@material-ui/core';
var alertTypes = {
    error: 'secondary',
    loggingIn: 'default',
    success: 'primary',
};
var defaultAlerts = {
    loggingIn: 'Logging in...',
    success: 'Login success!',
    error: 'Login error!',
};
var Alert = function (props) {
    var alerts = props.alerts, success = props.success, loggingIn = props.loggingIn, error = props.error;
    if (loggingIn) {
        return (React.createElement(Chip, { color: alertTypes.loggingIn, label: alerts.loggingIn || defaultAlerts.loggingIn }));
    }
    if (success) {
        return (React.createElement(Chip, { color: alertTypes.success, label: alerts.success || defaultAlerts.success }));
    }
    if (error) {
        return (React.createElement(Chip, { color: alertTypes.error, label: alerts.error || defaultAlerts.error }));
    }
    return null;
};
export default Alert;
//# sourceMappingURL=Alert.js.map